import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import Promise from 'bluebird';
import { injectIntl } from 'react-intl';
import { List } from 'immutable';
import classNames from 'classnames';
import '../../vendor/mouseevent-polyfill.js';
import PanelTree from './index';
import appConfig from '../../appConfig';
import { addError } from '../../actions/messageDialog';

const mapDispatchToProps = dispatch => ({
  addError: errMsg => dispatch(addError(errMsg)),
});

class PanelTreeItem extends Component {
  constructor(props) {
    super(props);

    // if true, this tree item is essentially used for categorisation and is not meant to be
    // interacted with
    const isHeaderType = this.props.type === 'CL' || this.props.type === 'CC';
    this.state = {
      isExpanded: props.isExpanded ||
        (props.isExpanded === undefined && !appConfig.collapseCategories && isHeaderType),
      isDragOver: false,
      isHeaderType,
    };

    this.onKeyDown = this.onKeyDown.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.onDragOver = this.onDragOver.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
    this.onExpand = this.onExpand.bind(this);
  }

  componentDidMount() {
    document.addEventListener('onkeydown', this.onKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('onKeyDown', this.onKeyDown);
  }

  onKeyDown(e) {
    if (e.metaKey || e.ctrlKey) {
      e.preventDefault();
    }
  }

  onClick(e) {
    e.preventDefault();
    this.props.onPanelItemClick(this.props.id,
      this.props.name,
      this.props.description,
      this.props.search
    );
  }

  onDrop(e) {
    this.setState({ isDragOver: false });
    if (this.props.canEdit) {
      this.props.onPanelItemDrop(e, this.props.id, false, this.props.canEdit);
    } else {
      this.props.addError(
        intl.formatMessage(
          { id: 'navCategoryPanel.noEditRoleError' },
          { catName: this.props.name }
        ));
    }
  }

  onDragLeave(e) {
    e.preventDefault();
    this.setState({ isDragOver: false });
  }

  onDragOver(e) {
    e.preventDefault();
    this.setState({ isDragOver: true });
  }

  onExpand() {
    this.setState({ isExpanded: !this.state.isExpanded }, () => {
      if (this.state.isExpanded && !this.state.isHeaderType) {
        this.props.retrievePanelTreeList(this.props.id, this.props.type);
      } else if (!this.state.isHeaderType) {
        this.props.clearPanelTreeList(this.props.id);
      } else {
        this.props.toggleCollectionCollapse(this.props.id);
      }
    });
  }

  mouseLeave() {
    const ev = new MouseEvent('click');
    document.dispatchEvent(ev, true);
  }

  render() {
    const {
      customIcons,
      hideTreeIcon,
      id,
      name,
      description,
      search,
      colour,
      panelTreeList,
      onPanelItemClick,
      onPanelItemDrop,
      retrievePanelTreeList,
      retrieveChildrenRequests,
      clearPanelTreeList,
      toggleCollectionCollapse,
      canEdit,
      editRequests,
      onEditSelect,
      editOptions,
      showContentCount,
      contentCount,
    } = this.props;

    const hasChildren = this.state.isHeaderType ?
      panelTreeList.size > 0 : this.props.hasChildren;

    // edit/wrench icon
    const edit = canEdit && !this.state.isHeaderType && onEditSelect && editOptions ?
      <Dropdown onSelect={(e, eKey) => onEditSelect(e, id, name, description)} className="btn-group">
        <Dropdown.Toggle
        variant="link"
        size="xs"
        id="panel-tree-edit-dropdown"
        >
          <span className="panel-item__option" />
        </Dropdown.Toggle>
          <Dropdown.Menu>
            {editOptions.map((editData, i) => {
              if (!(editData.eventKey === 'upload' && this.props.type !== 'C' && this.props.type !== 'B')) {
                return (<Dropdown.Item
                  key={i}
                  eventKey={editData.eventKey}
                >
                  {editData.label}
                </Dropdown.Item>);
              }
              })}
          </Dropdown.Menu>
      </Dropdown>
      :
      '';

    // custom icons -- i.e. pin icon for workspace
    const customIconEls =
      !this.state.isHeaderType && customIcons && customIcons.map((iconData, i) =>
        <button
          key={i}
          onClick={() => iconData.handler({
            workspaceID: id,
            workspaceName: name,
            workspaceDescription: description,
          })}
          className="panel-item__custom-icon"
        >
          <span className={iconData.iconClass} />
        </button>
      );

    const isEditing = editRequests && editRequests.getIn([id, 'request']) instanceof Promise;

    if (editRequests && editRequests.getIn([id, 'request']) instanceof Error) {
      console.warn(editRequests.getIn([id, 'request']), editRequests.get(id));
    }

    let labelElement;
    let labelIcon = <i />;

    if (this.state.isHeaderType) {
      if (!hideTreeIcon) {
        labelIcon = <i className="panel-item__header-icon" />;
      }

      labelElement = (<span className="panel-item__name--header">
        {labelIcon}{name}</span>);
    } else {
      if (!hideTreeIcon) {
        labelIcon = <i className="panel-item__item-icon" style={colour ? { color: `#${colour}` } : {}} />;
      }

      labelElement = (
        <a
          className={classNames('panel-item__name', {
            'panel-item__name--is-drag-over': this.state.isDragOver,
          })}
          id={id}
          href={null}
          onClick={this.onClick}
          data-name={name}
          data-editable={this.props.canEdit}
        >
          {labelIcon}
          {isEditing ? editRequests.getIn([id, 'workspaceName']) : name}
        </a>
      );
    }

    let count = '';
    if (showContentCount && search) {
      count = (<span className="panel-item__count">
        <i  />
      </span>);
    } else if (showContentCount && contentCount) {
      count = (<span className="panel-item__count">
        {contentCount}
      </span>);
    }

    return (
      <div
        className={classNames(
          'panel-item',
          { 'panel-item--no-children': !hasChildren }
        )}
      >
        <div
          className={classNames(
            'panel-item__link',
            {
              'panel-item__link--is-editing': isEditing,
              'panel-item__link--is-drag-over': this.state.isDragOver,
            }
          )}
          onMouseLeave={this.mouseLeave}
          onDrop={(!this.state.isHeaderType && this.props.onPanelItemDrop) ? this.onDrop : undefined}
          onDragOver={(!this.state.isHeaderType && this.props.onPanelItemDrop) ? this.onDragOver : undefined}
          onDragLeave={(!this.state.isHeaderType && this.props.onPanelItemDrop) ? this.onDragLeave : undefined}
        >
          {labelElement}
          {count}
          {edit}{customIconEls}
        </div>

        {hasChildren &&
          <i
            className={classNames(
              'panel-item__icon',
              {
                'panel-item__icon--expanded':
                  this.state.isExpanded && !retrieveChildrenRequests.get(id),
                'panel-item__icon--collapsed':
                  !this.state.isExpanded && !retrieveChildrenRequests.get(id),
                'panel-item__icon--loading':
                  retrieveChildrenRequests.get(id) &&
                    !(retrieveChildrenRequests.get(id) instanceof Error),
                'panel-item__icon--error':
                  retrieveChildrenRequests.get(id) &&
                    retrieveChildrenRequests.get(id) instanceof Error,
              }
            )}
            onClick={this.onExpand}
          />
        }
        {this.state.isExpanded && <div className="panel-item__children"><PanelTree
          retrievePanelTreeList={retrievePanelTreeList}
          retrieveChildrenRequests={retrieveChildrenRequests}
          clearPanelTreeList={clearPanelTreeList}
          toggleCollectionCollapse={toggleCollectionCollapse}
          onPanelItemClick={onPanelItemClick}
          onPanelItemDrop={onPanelItemDrop}
          panelTreeList={panelTreeList}
          editRequests={editRequests}
          customIcons={customIcons}
          onEditSelect={onEditSelect}
          editOptions={editOptions}
          showContentCount={showContentCount}
          contentCount={contentCount}
        /></div>}
      </div>
    );
  }
}

PanelTreeItem.propTypes = {
  customIcons: PropTypes.arrayOf(PropTypes.shape({
    iconClass: PropTypes.string,
    handler: PropTypes.func,
  })),
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  description: PropTypes.string,
  search: PropTypes.string,
  colour: PropTypes.string,
  hasChildren: PropTypes.bool,
  panelTreeList: PropTypes.instanceOf(List),
  onPanelItemClick: PropTypes.func,
  onPanelItemDrop: PropTypes.func,
  retrievePanelTreeList: PropTypes.func,
  retrieveChildrenRequests: PropTypes.shape({}),
  clearPanelTreeList: PropTypes.func,
  toggleCollectionCollapse: PropTypes.func,
  canEdit: PropTypes.bool,
  editRequests: PropTypes.shape({}),
  onEditSelect: PropTypes.func,
  showContentCount: PropTypes.bool,
  contentCount: PropTypes.string,
  editOptions: PropTypes.arrayOf(PropTypes.shape({
    eventKey: PropTypes.string,
    label: PropTypes.string,
  })),
  addError: PropTypes.func,
  isExpanded: PropTypes.bool,
};

export default injectIntl(connect(null, mapDispatchToProps)(PanelTreeItem));



// WEBPACK FOOTER //
// ./src/js/components/PanelTree/PanelTreeItem.jsx